import { ArrowRight } from 'lucide-react'

import { Button } from '@/components'
import type { PlanKind } from '@/modules/account/types'
import { getCourtoisDemoUrl } from '@/services/courtois'
import { cn } from '@/utils'

interface DemoCalloutProps {
  variant: Extract<PlanKind, 'single_project' | 'subscription'>
}

const COPY = {
  single_project: {
    heading: 'Doing this matter after matter?',
    description:
      "We offer a premier plan for firms whose regular work needs the math to reconcile and messy records deduped, matter after matter. Talk to us and we'll set you up.",
  },
  subscription: {
    heading: 'Not sure what to decide, or want a tailored demo?',
    description:
      "Tell us about your caseload and we'll help you find the right fit.",
  },
} as const

export const DemoCallout = ({ variant }: DemoCalloutProps) => {
  const { heading, description } = COPY[variant]

  return (
    <div
      className={cn(
        'flex flex-col gap-3 rounded-2xl border border-dashed border-input bg-muted p-5 sm:px-6 xl:px-8 xl:py-6',
        'sm:flex-row sm:items-center sm:justify-between',
      )}
    >
      <div>
        <h3 className="text-sm font-semibold tracking-tight">{heading}</h3>
        <p className="mt-0.5 text-sm text-muted-foreground text-pretty">
          {description}
        </p>
      </div>

      <Button asChild theme="outline" className="shrink-0">
        <a
          href={getCourtoisDemoUrl()}
          target="_blank"
          rel="noopener noreferrer"
        >
          Book a demo
          <ArrowRight className="h-4 w-4" />
        </a>
      </Button>
    </div>
  )
}
